<div class="orders-page">

    <!-- Header -->
    <div class="page-header">


        <button class="back-btn" (click)="goBack()">
            <i *ngIf="!isRTL" class="bi bi-arrow-left"></i>
            <i *ngIf="isRTL" class="bi bi-arrow-right"></i>
        </button>
        <h1 class="page-title">{{ 'ORDERS.TITLE' | translate }}</h1>


    </div>

    <!-- Filter tabs -->
    <div class="tabs-wrapper">
        <div class="tabs-scroll">
            <button *ngFor="let tab of tabs" class="tab-btn" [class.active]="activeFilter === tab.key"
                (click)="applyFilter(tab.key)">
                {{ 'ORDERS.TAB_' + tab.key | translate }}
            </button>
        </div>
    </div>

    <!-- Loading -->
    <div class="loading-state" *ngIf="isLoading">
        <div class="skeleton-card" *ngFor="let i of [1,2,3]"></div>
    </div>

    <!-- Empty state -->
    <div class="empty-state" *ngIf="!isLoading && filteredOrders.length === 0">
        <i class="bi bi-bag-x"></i>
        <p>{{ 'ORDERS.EMPTY' | translate }}</p>
    </div>

    <!-- Orders list -->
    <div class="orders-list" *ngIf="!isLoading && filteredOrders.length > 0">
        <div class="order-card" *ngFor="let order of filteredOrders; trackBy: trackByOrder"
            (click)="goToDetails(order)">

            <!-- Top row: order number + status -->
            <div class="card-top">
                <div class="order-info">
                    <p class="order-num">{{ 'ORDERS.ORDER_NO' | translate }} {{ order.orderNumber }}</p>
                    <p class="order-date">{{ formatDate(order.createdAt) }}</p>
                </div>
                <span class="status-badge" [ngClass]="'status-' + order.status.toLowerCase()">
                    {{ 'ORDERS.STATUS_' + order.status | translate }}
                </span>
            </div>

            <!-- Divider -->
            <div class="card-divider"></div>

            <!-- Bottom row: items count + total + arrow -->
            <div class="card-bottom">
                <span class="items-count">
                    {{ totalItems(order) }} {{ 'ORDERS.ITEMS' | translate }}
                </span>
                <div class="bottom-right">
                    <span class="order-total">
                        {{ order.total | currency:'EGP':'symbol':'1.0-0' }}
                    </span>
                    <i *ngIf="!isRTL" class="bi bi-chevron-right"></i>
                    <i *ngIf="isRTL" class="bi bi-chevron-left"></i>
                </div>
            </div>

        </div>
    </div>

</div>